var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.706 1.886c-2.913 0-4.943 2.282-4.943 4.33 0 1.732-.48 2.533-.905 3.24-.341.567-.61 1.015-.61 1.99.139 1.57 1.176 2.397 6.458 2.397 5.252 0 6.322-.863 6.46-2.452-.002-.92-.271-1.368-.612-1.936-.425-.706-.906-1.507-.906-3.24 0-2.047-2.03-4.329-4.942-4.329zm0 13.207c-3.897 0-7.418-.275-7.706-3.595-.002-1.373.417-2.071.787-2.686.374-.623.726-1.21.726-2.597 0-2.694 2.489-5.579 6.193-5.579 3.704 0 6.192 2.885 6.192 5.58 0 1.385.353 1.973.727 2.596.37.615.79 1.313.79 2.633-.292 3.373-3.813 3.648-7.71 3.648zM7.665 18.553h-.002c-.934-.001-1.818-.413-2.489-1.16a.624.624 0 11.93-.835c.431.48.985.745 1.56.745h.001c.578 0 1.134-.264 1.567-.746a.626.626 0 01.929.837c-.673.747-1.56 1.159-2.496 1.159z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.973029aa.svg";
export { ForwardRef as ReactComponent };